import { Box, Flex, Text } from '@podiumhq/design-system';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';
import useScrollToTopOnLoad from 'hooks/useScrollToTopOnLoad';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';

import CreditCardFields from '../CreditCardDetails/CreditCardFields';
import CreditCardIconsRow from '../CreditCardDetails/CreditCardIconsRow';

import { ErrorNotification } from './components/ErrorNotification';
import { BillingAddressOptionsForm } from './components/FormItems';
import SelectPlanTermForm from './components/FormItems/SelectPlanTermForm';
import {
  SelectPlanCheckoutContentBox,
  SelectPlanCheckoutContentFlexWrapper,
  CheckoutDescription,
  CheckoutTitle,
} from './components/layout';
import SelectedPlanSummary from './components/SelectedPlanSummary';
import { usePaymentView } from './hooks';
import {
  paymentDetailsTitleStyles,
  SelectPlanCheckoutButton,
  SelectPlanCheckoutPaymentFieldsWrapper,
} from './styles';

const PaymentView = () => {
  const { canChangePricingTerm, isMobile, selectedTerm, setSelectedTerm } =
    useCheckoutContext() || {};
  const {
    handleContinueClick,
    isSubmitting,
    setUpPurchaseIntentError,
    stripeError,
  } = usePaymentView();
  useScrollToTopOnLoad();
  useTrackAmplitudeEvent('selectPlanCheckout.paymentInfo.visited');

  return (
    <>
      <CheckoutTitle>How do you want to pay?</CheckoutTitle>
      <CheckoutDescription mb="40px">
        Add your payment info and billing address.
      </CheckoutDescription>

      <SelectPlanCheckoutContentFlexWrapper>
        {isMobile && <SelectedPlanSummary mb="21px" maxWidth="100%" />}

        <SelectPlanCheckoutContentBox>
          {canChangePricingTerm && (
            <Box mb="32px">
              <Text {...paymentDetailsTitleStyles}>Plan Type</Text>
              <SelectPlanTermForm
                onChange={setSelectedTerm}
                selectedTermValue={selectedTerm}
              />
            </Box>
          )}

          <SelectPlanCheckoutPaymentFieldsWrapper>
            <Flex align="flex-start" justify="space-between">
              <Text {...paymentDetailsTitleStyles}>Card Information</Text>
              <CreditCardIconsRow mr="10px" />
            </Flex>

            <ErrorNotification errorMessage={stripeError} shouldScrollToError />

            <CreditCardFields
              fullWidthForm={isMobile}
              trackOnBlurPath="selectPlanCheckout.paymentInfo"
            />
          </SelectPlanCheckoutPaymentFieldsWrapper>

          <BillingAddressOptionsForm />

          <ErrorNotification
            errorMessage={setUpPurchaseIntentError}
            mt="24px"
            shouldScrollToError
          />

          <SelectPlanCheckoutButton
            disabled={isSubmitting}
            fillColor="blue.base"
            id="payment-view-continue-button"
            isLoading={isSubmitting}
            margin="32px 0 20px 0"
            onClick={handleContinueClick}
            width="100%"
          >
            Continue to checkout
          </SelectPlanCheckoutButton>
        </SelectPlanCheckoutContentBox>

        {!isMobile && <SelectedPlanSummary mb="0" maxWidth="360px" />}
      </SelectPlanCheckoutContentFlexWrapper>
    </>
  );
};

export default PaymentView;
